import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthDashboardGuard } from 'guards/auths/auth-dashboard/auth-dashboard.guard';
import { AuthLoginGuard } from 'guards/auths/auth-login/auth-login.guard';
import { onboardingQaGuard } from 'guards/onboarding-qa/onboarding-qa.guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [AuthLoginGuard],
    loadChildren: () => import('./brain-auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthDashboardGuard],
    loadChildren: () => import('./brain-dashboard/dashboard.module').then(m => m.DashboardModule),
  },
  {
    path: 'portal',
    loadChildren: () => import('./brain-portal/portal.module').then(m => m.PortalModule),
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./brain-onboarding/onboarding.module').then(m => m.OnboardingModule),
  },
  {
    path: 'onboarding-setup',
    canActivate: [onboardingQaGuard],
    loadChildren: () => import('./brain-onboarding-setup/onboarding-setup.routes').then(m => m.ONBOARDING_SETUP_ROUTES),
  },
  {
    path: 'public',
    loadChildren: () => import('./brain-public/public.module').then(m => m.PublicModule),
  },
  {
    // BRN-2208: the explicit unenriched-session state. Registered at the top level, deliberately
    // OUTSIDE every guard: the user holds a valid access token, so `AuthLoginGuard` would bounce
    // them off `/auth` and `AuthPortalGuard`'s subtree is exactly what their token cannot use --
    // either would restart the loop this state exists to end.
    path: 'session/unenriched',
    loadComponent: () => import('./brain-auth/pages/unenriched-session/unenriched-session.component').then(m => m.UnenrichedSessionComponent),
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
